/* Bluestone & Basil: save recipes (hearts). Saved handles live in localStorage on this phone or computer. */
(function(){
  var KEY='bb_saved';
  function get(){ try{ return JSON.parse(localStorage.getItem(KEY)||'[]'); }catch(e){ return []; } }
  function put(a){ try{ localStorage.setItem(KEY,JSON.stringify(a)); }catch(e){} document.dispatchEvent(new CustomEvent('bb:saved')); }
  var toast, tt;
  function say(html){
    if(!toast){ toast=document.createElement('div'); toast.className='bb-toast'; toast.setAttribute('role','status'); document.body.appendChild(toast); }
    toast.innerHTML=html; toast.classList.add('is-on'); clearTimeout(tt); tt=setTimeout(function(){ toast.classList.remove('is-on'); },3600);
  }
  window.bbSay=say;
  function paint(b){ var on=get().indexOf(b.getAttribute('data-bb-save'))>-1; b.setAttribute('aria-pressed',on?'true':'false'); var t=b.querySelector('[data-bb-save-text]'); if(t) t.textContent=on?'Saved':'Save'; if(!t) b.setAttribute('aria-label', on?'Remove from saved recipes':'Save this recipe'); }
  function paintAll(){ [].forEach.call(document.querySelectorAll('[data-bb-save]'),paint); var c=get().length; [].forEach.call(document.querySelectorAll('[data-bb-saved-count]'),function(el){ el.textContent=c?c:''; el.hidden=!c; }); }
  document.addEventListener('click',function(e){
    var b=e.target.closest && e.target.closest('[data-bb-save]'); if(!b) return;
    e.preventDefault(); e.stopPropagation();
    var h=b.getAttribute('data-bb-save'), a=get(), i=a.indexOf(h);
    if(i>-1){ a.splice(i,1); put(a); say('Removed from your saved recipes'); }
    else { a.unshift(h); put(a); say('Saved. <a href="/pages/saved-recipes">See your saved recipes</a>'); }
    paintAll();
  });
  document.addEventListener('bb:saved',paintAll);
  if(document.readyState!=='loading') paintAll(); else document.addEventListener('DOMContentLoaded',paintAll);
})();
